exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tiles[data-v-507adaac]{display:grid;grid-template-columns:repeat(auto-fit,280px);grid-row-gap:5px;grid-column-gap:20px;width:100%;place-content:left;margin-top:5px;align-self:start}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Dashboard.vue"],"names":[],"mappings":"AACA,wBACE,aAAc,AACd,6CAA+C,AAC/C,iBAAkB,AAClB,qBAAsB,AACtB,WAAY,AACZ,mBAAoB,AACpB,eAAgB,AAChB,gBAAkB,CACnB","file":"Dashboard.vue","sourcesContent":["\n.tiles[data-v-507adaac] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 280px);\n  grid-row-gap: 5px;\n  grid-column-gap: 20px;\n  width: 100%;\n  place-content: left;\n  margin-top: 5px;\n  align-self: start;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-507adaac","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Dashboard.vue
// module id = 2062
// module chunks = 16